import React from "react";
import * as styles from "./ExcursionAccessibilityLevel.module.scss";
import { t, Trans } from "@lingui/macro";
import classNames from "classnames";
import { i18n } from "@lingui/core";
import { Icon } from "@silversea-ssc/ui-components-react";

export interface ExcursionAccessibilityLevelProps {
  level: string;
  showDescription?: boolean;
  titleClassName?: string;
  size: "small" | "big";
}

const unknownLevel = {
  fullIcons: 0,
  label: "",
  description: ""
};

const levelsDefinitions = {
  limited: {
    fullIcons: "limited",
    label: t`accessibility-limited-label`,
    shortDescription: t`accessibility-limited-short-description`,
    description: t`accessibility-limited-description`
  },
  accessibility: {
    fullIcons: "accessibility",
    label: t`accessibility-severe-label`,
    shortDescription: t`accessibility-severe-short-description`,
    description: t`accessibility-severe-description`
  }
};

const ExcursionAccessibilityLevel: React.FC<ExcursionAccessibilityLevelProps> = ({
  level,
  showDescription = false,
  titleClassName = undefined,
  size
}) => {
  const { fullIcons, label, description } =
    levelsDefinitions[level] || unknownLevel;

  return (
    <div
      className={classNames({
        [styles.container]: true,
        [styles.withDescription]: showDescription,
        [styles.sizeBig]: size == "big"
        //[styles.sizeSmall]: size == "small"
      })}
    >
      <div
        className={classNames({
          [styles.title]: true,
          [titleClassName || ""]: titleClassName
        })}
      >
        <Trans>Accessibility</Trans>
      </div>
      <div className={styles.body}>
        <Icon
          name={fullIcons}
          className={styles.icon}
          size="2x"
          padding="inline"
        />{" "}
        <span>
          {i18n._(label)}
          {showDescription ? (
            <span className={styles.description}>
              <br />
              {i18n._(description)}
            </span>
          ) : null}
        </span>
      </div>
    </div>
  );
};

export default ExcursionAccessibilityLevel;
